import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from "reactstrap";
import { useReenableRenewalMutation } from "../campaigns-api-endpoints";

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  reenableRenewalLink: PropTypes.string.isRequired
};

const ReenableRenewalModal = ({ isOpen, onClose, reenableRenewalLink }) => {
  const [succeeded, setSucceeded] = useState(false);
  const [reenableRenewal, { isLoading, error }] = useReenableRenewalMutation();

  const handleConfirm = async () => {
    const result = await reenableRenewal({ url: reenableRenewalLink });
    if (!result.error) {
      setSucceeded(true);
    }
  };

  const handleClose = () => {
    setSucceeded(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={isLoading ? undefined : handleClose}
      fade={false}
      className="account-app modal-dialog-centered"
    >
      <ModalHeader toggle={isLoading ? undefined : handleClose} />
      <ModalBody className="px-4 pt-0 pb-3 text-center">
        {succeeded ? (
          <>
            <h5 className="font-weight-bold mb-3 text-success">Success!</h5>
            <p>Your campaign has been set to renew automatically.</p>
          </>
        ) : (
          <>
            <h5 className="font-weight-bold mb-3">Re-enable Renewal</h5>
            <p>Your campaign will be set to renew automatically. Would you like to continue?</p>
            {error && (
              <Alert color="danger">An error occurred re-enabling renewal. Please try again.</Alert>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        {succeeded ? (
          <Button color="primary" className="btn-sharp" onClick={handleClose}>
            Done
          </Button>
        ) : (
          <>
            <Button
              color="secondary"
              className="btn-sharp"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              className="btn-sharp"
              data-testid="reenable-renewal-submit"
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Re-enable Renewal"}
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
};

ReenableRenewalModal.propTypes = propTypes;

export default ReenableRenewalModal;
